import Checkbox from 'components/Form/Checkbox/Checkbox'
import ErrorMessage from 'components/Form/ErrorMessage/ErrorMessage'
import { useState } from 'react'
import { FieldValues, useController, UseControllerProps } from 'react-hook-form'
import styles from './Checkboxes.module.scss'

type ChecboxesProps = UseControllerProps<FieldValues> & {
  subtitle: string
  options: object
  type: 'radio' | 'checkbox'
}

const Checkboxes = ({ subtitle, options, type, control, name, rules }: ChecboxesProps) => {
  const {
    field,
    fieldState: { error },
  } = useController({ control, name, rules })
  const [fieldValue, setFieldValue] = useState(field.value || [])

  return (
    <section className={styles.checkboxes}>
      <span className={styles.subtitle}>{subtitle}</span>
      <ul className={styles.list}>
        {Object.entries(options).map(([key, value]) => (
          <Checkbox
            id={`${key.toLowerCase()}-checkbox`}
            key={key}
            type={type}
            option={value}
            label={value}
            fieldValue={fieldValue}
            setFieldValue={setFieldValue}
            field={field}
          />
        ))}
      </ul>
      <ErrorMessage error={error} />
    </section>
  )
}

export default Checkboxes
